import React, { useEffect, useState } from "react";
import { MdEvent } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import { useStateContext } from "../../contexts/ContextProvider";

import { Calendar } from "primereact/calendar";
import "primereact/resources/themes/lara-light-cyan/theme.css";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import moment from "moment";

import { Form } from "react-bootstrap";

import Select from "react-select";

import EventService from "../../services/event.services";
import DashboardService from "../../services/dashboard.service";
import { Flex } from "antd";

const AddEvent = () => {
  const { event, setEvent, fetchAllEvents, employees } = useStateContext();

  const [validated, setValidated] = useState(false);

  const [types, setTypes] = useState([]);

  const empOpts = employees.map((item) => ({
    value: item.empId,
    label: item.name,
  }));

  const initialData = {
    subject: "",
    description: "",
    date: "",
    formatedDate: "",
    startTime: "",
    endTime: "",
    employee: "",
    type: "",
  };

  const [details, setDetails] = useState(initialData);

  const currentDate = new Date();
  const maxDate = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1,
  );

  const [date, setDate] = useState(new Date());

  const handleChange = (e) => {
    setDate(e.value);
    setDetails({
      ...details,
      date: moment(new Date(e.value)).format("YYYY-MM-DD"),
      formatedDate: moment(new Date(e.value)).format("D MMM YYYY"),
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDetails({
      ...details,
      [name]: value,
    });
  };

  const fetchTypes = () => {
    DashboardService.getEventtypes()
      .then((resp) =>
        resp.data
          ? setTypes(
              resp.data.map((item) => ({
                value: item.typeId,
                label: item.typeName,
              })),
            )
          : null,
      )
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    fetchTypes();
  }, []);

  const handleSelect = (e, key) => {
    setDetails({ ...details, [key]: e });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      setValidated(true);
      toast.warn("* Please fill all required fields!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    const data = {
      subject: details.subject,
      description: details.description,
      date: moment(new Date(date)).format("YYYY-MM-DD"),
      starttime: details.startTime,
      endtime: details.endTime,
      employee: details.employee.value,
      type: details.type.value,
    };

    // console.log(data);

    EventService.addEvent(data)
      .then((resp) => {
        if (resp.data) {
          setDetails(initialData);
          toast.success("Event Added Successfully", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            onClose: () => setEvent(false),
          });
          fetchAllEvents();
        }
      })
      .catch((e) => console.log(e));
  };

  // console.log("employees", employees)

  return (
    <>
      <div className={`${event ? "add-event visible" : "add-event hidden"}`}>
        <Flex className="mb-5" justify="space-between" align="center">
          <Flex className="left-flex" gap={10} align="center">
            <span className="icon">
              <MdEvent size={30} color="#4E465E" />
            </span>
            <span>Add an Event! </span>
          </Flex>
          <div className="close">
            <IoMdClose
              size={30}
              color="#4E465E"
              onClick={() => setEvent(false)}
            />
          </div>
        </Flex>

        <ToastContainer />
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <div className="event-form">
            <div className="mb-3 select">
              <Select
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    height: "45px",
                    fontSize: "16px",
                    lineHeight: "20px",
                    fontWeight: "500",
                    border: "1px solid rgba(210, 205, 218, 1)",
                  }),
                  option: (baseStyles, { isFocused, isSelected }) => ({
                    ...baseStyles,
                    fontSize: "16px",
                    lineHeight: "20px",
                    fontWeight: "500",
                    borderRadius: "4px",
                    backgroundColor: isSelected
                      ? "rgba(177, 206, 251, 1)"
                      : isFocused
                        ? "rgba(177, 206, 251, 1)"
                        : "rgba(255, 255, 255, 1)",
                    color: isSelected
                      ? "rgba(78, 70, 94, 1)"
                      : isFocused
                        ? "rgba(78, 70, 94, 1)"
                        : "rgba(78, 70, 94, 1)",
                  }),
                  menu: (baseStyles, state) => ({
                    ...baseStyles,
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                  }),
                }}
                options={types}
                onChange={(e) => handleSelect(e, "type")}
                value={details.type}
                placeholder="Select Event Type *"
                required
              />
            </div>
            <div className="mb-3 select">
              <Select
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    height: "45px",
                    fontSize: "16px",
                    lineHeight: "20px",
                    fontWeight: "500",
                    border: "1px solid rgba(210, 205, 218, 1)",
                  }),
                  option: (baseStyles, { isFocused, isSelected }) => ({
                    ...baseStyles,
                    fontSize: "16px",
                    lineHeight: "20px",
                    fontWeight: "500",
                    borderRadius: "4px",
                    backgroundColor: isSelected
                      ? "rgba(177, 206, 251, 1)"
                      : isFocused
                        ? "rgba(177, 206, 251, 1)"
                        : "rgba(255, 255, 255, 1)",
                    color: isSelected
                      ? "rgba(78, 70, 94, 1)"
                      : isFocused
                        ? "rgba(78, 70, 94, 1)"
                        : "rgba(78, 70, 94, 1)",
                  }),
                  menu: (baseStyles, state) => ({
                    ...baseStyles,
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                  }),
                }}
                options={empOpts}
                onChange={(e) => handleSelect(e, "employee")}
                value={details.employee}
                placeholder="Select Employee *"
                required
              />
            </div>
            <div className="mb-3">
              <input
                type="text"
                placeholder="Write subject *"
                name="subject"
                value={details.subject}
                required
                onChange={handleInputChange}
              />
            </div>
            <div className="mb-3">
              <textarea
                placeholder="Give information /details about event"
                name="description"
                value={details.description}
                onChange={handleInputChange}
              ></textarea>
            </div>
            <div className="mb-3 calendar-relative">
              <label htmlFor="leaveType" className="form-label">
                Select Date *
              </label>

              <div className="new-calendar-type flex justify-content-center month-year">
                <Calendar
                  value={date}
                  onChange={handleChange}
                  view="date"
                  dateFormat="dd, MM, yy"
                  style={{ width: "100%", height: "100%" }}
                  showIcon
                  // maxDate={maxDate}
                  selectOtherMonths
                  required
                />
              </div>
            </div>
            <div className="mb-3">
              <label htmlFor="leaveType" className="form-label">
                Select Start time
              </label>
              <input
                type="time"
                name="startTime"
                value={details.startTime}
                onChange={handleInputChange}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="leaveType" className="form-label">
                Select End time
              </label>
              <input
                type="time"
                name="endTime"
                value={details.endTime}
                onChange={handleInputChange}
              />
            </div>
          </div>
          <div className="event-action">
            <button>Submit</button>
          </div>
        </Form>
      </div>
    </>
  );
};

export default AddEvent;
